import { useState } from 'react';
import AdsSubTab from './performance/AdsSubTab';
import MetaSubTab from './performance/MetaSubTab';
import type { Franchisee } from '../types';

type Props = { franchisee: Franchisee | null };

type SubTabId = 'paid-ads' | 'paid-meta' | 'paid-youtube';

const SUBS: ReadonlyArray<{ id: SubTabId; label: string }> = [
  { id: 'paid-ads', label: 'Google Ads' },
  { id: 'paid-meta', label: 'Meta / Facebook' },
  { id: 'paid-youtube', label: 'YouTube' },
];

function PlaceholderPanel({ channel }: { channel: string }) {
  return (
    <div className="tab-placeholder">
      <h3>{channel}</h3>
      <p>Reporting for this channel isn't connected yet — metrics will appear here once the data source is wired up.</p>
    </div>
  );
}

export default function PaidPerformanceTab({ franchisee }: Props) {
  const [sub, setSub] = useState<SubTabId>('paid-ads');

  if (!franchisee) {
    return (
      <div className="tab-placeholder">
        <h3>Paid Performance</h3>
        <p>Select a franchisee to view their paid performance metrics.</p>
      </div>
    );
  }

  return (
    <>
      <div className="perf-sub-tabs">
        {SUBS.map((s) => (
          <button
            key={s.id}
            className={`perf-sub-btn ${sub === s.id ? 'active' : ''}`}
            onClick={() => setSub(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      {sub === 'paid-ads' && <AdsSubTab af={franchisee.af_number} />}
      {sub === 'paid-meta' && <MetaSubTab af={franchisee.af_number} />}
      {sub === 'paid-youtube' && <PlaceholderPanel channel="YouTube Ads" />}
    </>
  );
}
